import { Navigate } from 'react-router-dom';

import { FullPageSpinner } from './FullPageSpinner';
import { homeOf } from './home';
import { useSession } from './SessionContext';

/** An unknown path goes to the home of whoever is signed in, or to sign-in. */
export const HomeRedirect = () => {
  const { profile, isLoading } = useSession();

  if (isLoading) {
    return <FullPageSpinner />;
  }

  return <Navigate to={profile ? homeOf(profile.kind) : '/login'} replace />;
};
